import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-jiance",
  "use": "icon-jiance-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jiance\"><path d=\"M864 64H160c-35.296 0-64 28.704-64 64v768c0 35.296 28.704 64 64 64h704c35.296 0 64-28.704 64-64V128c0-35.296-28.704-64-64-64zM160 896v-57.344h96a32 32 0 1 0 0-64H160v-32h96a32 32 0 1 0 0-64H160V128h704l0.032 550.656H768a32 32 0 1 0 0 64h96.064v32H768a32 32 0 1 0 0 64h96.064V896H160z\" p-id=\"1712\" /><path d=\"M832 160H192v480h640V160z m-64 416H256V224h512v352z\" p-id=\"1713\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-jiance.svg
// module id = oQU6
// module chunks = 177